import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import Require from "~common/components/require"
import {Typography} from '@mui/material'
import TemplateEditView from "~templates/components/template-admin-edit-view"
import TemplateQueryList from "~templates/components/template-query-view"




const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  status: "loading" | "ready"
}

class TemplateAdmin extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {status: "ready"}
  }

  render() {

    const {match} = this.props;
    const { classes}: {classes: ClassNameMap} = this.props
    const { status} = this.state
    var selectedGroupID
    if(match && match.params && match.params.id) {
      selectedGroupID = match.params.id
    }


    var view 
    if (status === "loading") {
      view = <LoadingView classes={{}} />
    } else if (selectedGroupID) {
      view = <TemplateEditView templateId={selectedGroupID} history={history} classes={{}} />
    } else {
      view = <TemplateQueryList></TemplateQueryList> 
    }

    return (
      <AppView>
        <Require classes={{}} requireOneOfFeatures={["template_admin"]}>
            <Typography id="templateAdminTitle" variant="h5" className={classes.heading}>
               Template Administration
            </Typography>
            <div className={classes.container}>{view}</div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(TemplateAdmin)
